import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_USU_PERFILES,
  ALL_USU_PERFILES,
  LOADING_ALL_USU_PERFILES,
} from './UsuEntPerfilesReducer';
import {
  allUsuEntPerfilesService,
  deleteUsuEntPerfilesService,
  saveUsuEntPerfilesService,
} from './UsuEntPerfilesService';

export const allUsuEntPerfilesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_USU_PERFILES, payload: true });
    const res = await allUsuEntPerfilesService(params);
    dispatch({ type: ALL_USU_PERFILES, payload: res.data });
    dispatch({ type: LOADING_ALL_USU_PERFILES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_USU_PERFILES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveUsuEntPerfilesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveUsuEntPerfilesService(id, data);
    notify(res.data.message);
    await allUsuEntPerfilesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoUsuEntPerfilesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_USU_PERFILES, payload: data });
};

export const deleteUsuEntPerfilesAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteUsuEntPerfilesService(id);
    notify(res.data.message);
    await setActivoUsuEntPerfilesAction(dispatch, null);
    await allUsuEntPerfilesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
